import { render, staticRenderFns } from "./DoctorsClinic.vue?vue&type=template&id=7836153e&"
import script from "./DoctorsClinic.vue?vue&type=script&lang=js&"
export * from "./DoctorsClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports